exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".slider-group{margin-bottom:12px;overflow:hidden}.slider-group-box{display:flex;align-items:flex-start}.slider-input-box{display:flex;width:60%;justify-content:space-between;align-items:center;margin-bottom:10px}.slider-group-box button.btn-slider{width:auto;padding:5px 8px;margin-left:auto;line-height:1;height:auto;border-radius:6px;background-color:#0597cd}.slider-group-box__input{width:50px}.slider-group-box__input_salary{width:70px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/css-loader?minimize!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/style-rewriter.js?id=data-v-8430c904!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/selector.js?type=styles&index=0!./vue/frontfilter/components/Duration.vue
// module id = 47
// module chunks = 0 1